<template>
    <li
        ref="messageBlock"
        id="list-item"
        class="main-chat__item"
        @contextmenu="openMenu"
        :class="{'main-chat__item--mine' : userData.id === message.sender}"
        v-show="message.text || message.attachment !== undefined && message.attachment.path"
        v-if="memberSender && memberSender.id"
    >
        <router-link :to="`/personal-channel/${memberSender.id}`"
                     tag="a"
                     :style="{ cursor: 'pointer'}"
                     v-if="userData.id !== message.sender"
        >

            <img class="item__profile-image" :src="photo | imgSrc" alt=""
                 v-if="channelMember"
            >
            <img class="item__profile-image"
                 :src="env.public_base + '/assets/images/person-icon.png'" alt=""
                 v-else>
        </router-link>
        <a href="javascript:void(0)" v-else>
            <img class="item__profile-image" :src="photo | imgSrc" alt=""
                 v-if="channelMember"
            >
            <img class="item__profile-image"
                 :src="env.public_base + '/assets/images/person-icon.png'" alt=""
                 v-else>
        </a>
        <div class="item__content">
            <router-link :to="`/personal-channel/${memberSender.id}`"
                         tag="a"
                         :style="{ cursor: 'pointer'}"
                         v-if="userData.id !== message.sender"
            >
                <h4>{{ lastName }} {{ firstName }} {{ patronymicName }}</h4>
                <span v-if="studentGroups && $route.name !== 'personal-channel' && userData.role === 'teacher'"><strong>{{ $t("group") }}:</strong> {{ studentGroups }} </span>
                <span v-if="educationForm && $route.name !== 'personal-channel' && userData.role === 'teacher'"><strong>{{ $t("education_form") }}:</strong> {{ educationForm }} </span>
                <span v-if="interlocutorVarCourses && $route.name !== 'personal-channel' && userData.role === 'teacher'"><strong>{{ $t("var_courses_shot") }}:</strong> {{ interlocutorVarCourses }}</span>
            </router-link>
            <a href="javascript:void(0)" v-else>
                <h4>{{ lastName }} {{ firstName }} {{ patronymicName }}</h4>
                <span v-if="studentGroups && $route.name !== 'personal-channel' && userData.role === 'teacher'">{{ studentGroups }} </span>
                <span v-if="educationForm && $route.name !== 'personal-channel' && userData.role === 'teacher'">{{ educationForm }} </span>
                <span v-if="interlocutorVarCourses && $route.name !== 'personal-channel' && userData.role === 'teacher'"><strong>{{ $t("var_courses_shot") }}:</strong> {{ interlocutorVarCourses }}</span>
            </a>
            <p
                class="item-content__message"
                ref="message"
                v-html="messageText"
                v-if="messageText"
                @paste="sanitize"
                v-linkified:options="{ className: 'link' }"
            >
            </p>

            <div class="images-container" v-if="show && images.length || message.attachment">
                <silentbox-single
                    class="youtube-link"
                    :src="image.fullLink"
                    :description="image.title"
                    :style="{ width: image.width + 'px' }"
                    v-for="image in images"
                    :key="image.id"
                >
                    <img v-if="image.fullLink !== ''" :src="image.imageSrc">
                    <span>{{image.title}}</span>
                </silentbox-single>
            </div>

            <div class="spring-spinner" v-if="message.fileState && message.fileState.loader">
                <!--            <div class="spring-spinner" v-if="message.id === loader.chatMessageId && loader.loader">-->
                <div class="spring-spinner-part top">
                    <div class="spring-spinner-rotator"></div>
                </div>
                <div class="spring-spinner-part bottom">
                    <div class="spring-spinner-rotator"></div>
                </div>
            </div>

            <p v-else-if="message.attachment
            && !(/\.(gif|jpg|jpeg|tiff|png)$/i).test(message.attachment.path)
            && !(/\.(webm|wav)$/i).test(message.attachment.path)"
            class="attachment-file">
                <a target="_blank" :href="env.s3_url + message.attachment.path">{{ message.attachment.name }}</a>
            </p>

            <div class="images-container" v-if="message.attachment">
                <silentbox-single
                    class="image-link"
                    v-if="(/\.(gif|jpg|jpeg|tiff|png)$/i).test(message.attachment.path)"
                    :description="message.attachment.name"
                    :src="env.s3_url + message.attachment.path"
                    width="100%"
                >
                    <img :src="env.s3_url + message.attachment.path">
                </silentbox-single>
            </div>

            <div class="voice-message-container" v-if="message.attachment">
              <div v-if="(/\.(webm|wav)$/i).test(message.attachment.path)">

                <audio controls>
                  <source :src="env.s3_url + message.attachment.path" type="audio/wav">
                  Your browser does not support the audio element.
                </audio>

              </div>
            </div>


            <span style="display: none;">{{message.updated}}</span>
            <p class="item-content__date">{{ message.created | formatDateMmDdYyyy }}</p>

            <span class="item-content__edited"
                  v-if="timeInSec(message.created) !== timeInSec(message.updated) || !!message.edited">
                <img :src="env.public_base + '/assets/images/pencil-icon.svg'" alt="">
            </span>

            <app-whiteboard-link @click="getWhiteboardLink"
                                 :id="message.whiteboard ? message.whiteboard.id : whiteboardRoomId"
                                 v-if="
                                 userData.access_to_whiteboard
                                 && ((message.whiteboard && message.whiteboard.id) || whiteboardRoomId)"
            ></app-whiteboard-link>

            <div id="right-click-menu" tabindex="-1" ref="editModal" v-if="viewMenu"
                 :style="{top: editModal.top, left: editModal.left}"
            >
                <button type="button"
                        @click="getMessageData"
                        @blur="closeMenu"
                >
                    {{ $t('edit') }}
                </button>
                <button type="button"
                        v-if="(userData.role === 'admin' || userData.role === 'teacher') && message.text &&
                        channel.is_group && !techChatsIds.some(el => el === channelId)"
                        @click="pinMessage"
                        @blur="closeMenu"
                >
                    {{ $t('pin_message') }}
                </button>
            </div>
        </div>
    </li>
</template>

<script>
    import {mapGetters} from 'vuex';
    import WhiteboardLink from './WhiteboardLink.vue';
    import env from '../../env';
    import axios from 'axios'
    import Vue from 'vue'
    import eventBus from "../../courses/eventBus";

    export default {
        props: ['message'],
        data: () => ({
            env,
            imageSrc: '',
            title: '',
            hasLink: false,
            fullLink: '',
            width: 180,
            images: [],
            showMessage: true,
            show: false,
            viewMenu: false,
            editModal: {
                top: '0px',
                left: '0px'
            },
        }),
        components: {
            appWhiteboardLink: WhiteboardLink,
        },
        computed: {
            ...mapGetters([
                'channel',
                'channelMembers',
                'channelCurrentMembers',
                'userData',
                'mainChat',
                'messages',
                'techChat',
                'techChatsIds',
                'channelId',
            ]),
            whiteboardRoomId() {
                const regex = this.message.text.match(/(\#wb=)(\d*)(\#)/)
                if (regex && regex.length > 3) {
                    return regex[2]
                } else {
                    return false
                }
            },
            messageText() {
                // whiteboard hidden room id
                return this.message.text.replace(/&nbsp;/g, ' ').replace(/&#39;/g, "'").replace("&amp;", "&").replace(/\#(.*?)\#/, '');
            },
            fileLoaded() {
                let state = true;
                Object.entries(this.messages).forEach(item => {
                    if (item[0] == this.message.id && typeof item[1].fileState !== 'undefined') {
                        if (this.message.text == '') {
                            return state = !item[1].fileState.error
                        }
                        return item[1];
                    }
                });
            },
            loader() {
                return this.mainChat.fileLoader
            },
            memberSender() {
                return this.channelMembers[this.message.sender]
            },
            currentMemberSender() {
                return this.channelCurrentMembers[this.message.sender]
            },
            firstName() {
                return typeof this.memberSender !== 'undefined' && typeof this.memberSender.first_name !== "undefined"
                    ? this.memberSender.first_name
                    : typeof this.currentMemberSender !== 'undefined' && typeof this.currentMemberSender.first_name !== 'undefined'
                        ? this.currentMemberSender.first_name
                        : 'Stub first name'
            },
            lastName() {
                return typeof this.memberSender !== 'undefined' && typeof this.memberSender.last_name !== "undefined"
                    ? this.memberSender.last_name
                    : typeof this.currentMemberSender !== 'undefined' && typeof this.currentMemberSender.last_name !== 'undefined'
                        ? this.currentMemberSender.last_name
                        : 'Stub last name'
            },
            patronymicName() {
                return typeof this.memberSender !== 'undefined' && typeof this.memberSender.patronymic !== "undefined" && this.memberSender.role === 'teacher'
                    ? this.memberSender.patronymic
                    : typeof this.currentMemberSender !== 'undefined' && typeof this.currentMemberSender.patronymic !== 'undefined' && this.currentMemberSender.role === 'teacher'
                        ? this.currentMemberSender.patronymic
                        : ''
            },
            studentGroups() {
                if (!this.channel) return null;

                const authors = this.channel.author_members || {};

                if (typeof authors !== 'object') return null;

                const senderId = this.message?.sender;
                const sender = Object.values(authors).find((author) => author.id === senderId);

                if (!sender) return null;

                const isStudent = ['student', 'student/billing'].includes(sender.role);
                
                if (!isStudent) return null;

                const groups = sender.students_groups;
                
                if (!groups) return null;

                const groupsName = groups.map((group) => group.name);
                
                return groupsName.join(', ') || null;

                // let studentsGroups = [];
                // let groupsName = [];
                // if (typeof this.memberSender !== 'undefined' && typeof this.memberSender.students_groups !== "undefined" && (this.memberSender.role === 'student' || this.memberSender.role === 'student/billing')) {
                //     studentsGroups = this.memberSender.students_groups
                // } else if (typeof this.currentMemberSender !== 'undefined' && typeof this.currentMemberSender.students_groups !== 'undefined' && (this.currentMemberSender.role === 'student' || this.currentMemberSender.role === 'student/billing')) {
                //     studentsGroups = this.currentMemberSender.students_groups
                // }
                // studentsGroups.forEach(group => {
                //     groupsName.push(group.name.slice(0, 3))
                // });
                // return groupsName.join(', ')
            },
            educationForm() {
                var eduForm;
                if (typeof this.memberSender !== 'undefined' && typeof this.memberSender.ed_form !== "undefined" && (this.memberSender.role === 'student' || this.memberSender.role === 'student/billing')) {
                    eduForm = this.memberSender.ed_form
                } else if (typeof this.currentMemberSender !== 'undefined' && typeof this.currentMemberSender.ed_form !== 'undefined' && (this.currentMemberSender.role === 'student' || this.currentMemberSender.role === 'student/billing')) {
                    eduForm = this.currentMemberSender.ed_form
                }

                return eduForm
            },
            photo() {
                if (typeof this.currentMemberSender !== 'undefined' && this.currentMemberSender.photo) {
                    return this.currentMemberSender.photo;
                } else if (typeof this.memberSender !== 'undefined' && this.memberSender.photo) {
                    return this.memberSender.photo
                } else {
                    return '';
                }
            },
            channelMember() {
                return !!(typeof this.currentMemberSender !== 'undefined' && this.currentMemberSender.photo
                    || typeof this.memberSender !== 'undefined' && this.memberSender.photo)
            },
            interlocutorVarCourses() {
                if (!this.channel) return null;

                const authors = this.channel.author_members || {};

                if (typeof authors !== 'object') return null;

                const senderId = this.message?.sender;
                const sender = Object.values(authors).find((author) => author.id === senderId);

                if (!sender) return null;

                const isStudent = ['student', 'student/billing'].includes(sender.role);
                
                if (!isStudent) return null;

                const courses = sender?.var_courses || [];
                
                return courses.join(', ') || null;
            },
        },
        methods: {
            pinMessage() {
                if(!this.messageText) return;
                let data = {
                    text: this.messageText,
                    messageId: this.message.id,
                    pin: true,
                    author: {
                        first_name: this.userData.first_name,
                        last_name: this.userData.last_name,
                        patronymic: this.userData.patronymic,
                    },
                    created: this.message.created,
                    student_groups_ids: this.message.student_groups_ids,
                };
                console.log(data, "data");
                eventBus.$emit('pin_message', data);
                this.closeMenu();
            },
            getWhiteboardLink() {
                this.$store.dispatch('getWhiteboardLink', this.message).then(data => {
                    if (data) {
                        // TODO: create new tab using target="_blank"
                        this.$router.push(data.link)
                    }
                }, err => console.log(err));
            },

            timeInSec(time) {
                return Math.floor(new Date(time).getTime() / 1000)
            },

            sanitize(event) {
                event.preventDefault();
                const html = this.$sanitize(event.clipboardData.getData('text/html'));
                document.execCommand('insertHTML', false, (html));
            },

            formatYoutube() {
                this.message.text = this.message.text.replace(/&nbsp;/g, ' ').replace(/&#39;/g, "'").replace("&amp;", "&");

                if (this.message.text.match(/https:\/\/www.youtube.com\/watch\?/g)) {
                    let allYoutubeLinks = this.message.text.match(/https:\/\/www.youtube.com\/watch\?v=[A-Za-z0-9-\_\--]{11}/g);

                    if (allYoutubeLinks == null || typeof allYoutubeLinks === 'undefined' || allYoutubeLinks.length === 0) return;
                    allYoutubeLinks.forEach((item, index) => {

                        let linkPos = this.message.text.indexOf(item),
                            videoId = this.message.text.substr(linkPos + 'https://www.youtube.com/watch?v='.length, 11),
                            fullLink = this.message.text.substr(linkPos, 'https://www.youtube.com/watch?v='.length + 11),
                            data = {
                                title: '',
                                width: 180,
                                imageSrc: '',
                                hasLink: true,
                                linkPos: linkPos,
                                videoId: videoId,
                                fullLink: fullLink,
                                id: index
                            };

                        axios.get(`https://www.googleapis.com/youtube/v3/videos?id=${data.videoId}&key=${this.env.api_key}&part=snippet`)
                            .then(response => {
                                data.imageSrc = response.data.items[0].snippet.thumbnails.medium.url;
                                data.width = response.data.items[0].snippet.thumbnails.medium.width;
                                data.title = response.data.items[0].snippet.title;

                                this.show = true;
                            })
                            .catch(err => {
                                this.show = false;
                                console.log(err)
                            });

                        this.images.push(data)
                    })
                }
            },

            setMenu(top, left) {
                let largestHeight = window.innerHeight - this.$refs.editModal.offsetHeight - 25;
                let largestWidth = window.innerWidth - this.$refs.editModal.offsetWidth - 25;

                if (top > largestHeight) top = largestHeight;

                if (left > largestWidth) left = largestWidth;

                this.editModal.top = top + 'px';
                this.editModal.left = left + 'px';
            },

            closeMenu() {
                this.viewMenu = false;
            },

            openMenu(e) {
                // check for sender
                if ((this.userData.id === this.message.sender)
                    || (this.techChatsIds.some(el => el === this.channelId) && this.userData.role === 'admin' ||
                        this.userData.role === 'modarator')) {
                    // technical chat check for role
                    this.viewMenu = true;
                    Vue.nextTick(function () {
                        this.$refs.editModal.focus();

                        this.setMenu(e.y, e.x)
                    }.bind(this));
                    e.preventDefault();
                }
            },

            getMessageData() {
                let data = {
                    text: this.messageText,
                    messageId: this.message.id,
                    changed: true,
                    student_groups_ids: this.message.student_groups_ids
                };
                console.log(this.message, "message");
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'editMessage', value: data});
                this.closeMenu();
            },
        },
        created() {
            const mainChatSection = document.getElementById("main-chat-section"),
                mainChat = document.getElementById('mainChat').clientHeight;
            // this.formatYoutube();

            if ((this.memberSender &&
                this.memberSender.id === this.userData.id)
                && (this.message.text
                || this.message.attachment !== undefined
                && this.message.attachment.path) && typeof this.message.unread === 'undefined'
            ) {
                setTimeout(() => {
                    mainChatSection.scrollTop = mainChat;
                }, 0)
            }

            document.addEventListener('click', e => {
                let menu = document.getElementById('right-click-menu')
                if(e.target !== menu) this.closeMenu();
            })
        },
        destroyed() {
            document.removeEventListener('click', e => {
                let menu = document.getElementById('right-click-menu')
                if(e.target !== menu) this.closeMenu();
            });
        }
    }
</script>

<style lang="sass">
    @import "../../../sass/variables"

    #list-item
        width: 100%
        height: 100%


    #right-click-menu
        z-index: 99999
        position: fixed
        width: fit-content
        margin: 0
        display: flex
        align-items: flex-start
        flex-direction: column

        outline: none
        cursor: pointer
        background: #FFF
        border: 1px solid #BDBDBD
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)

        transition: color, background-color, border-bottom 330ms ease

        button
            color: $black
            width: 100%
            padding: 5px 10px
            text-align: left
            background: transparent

            &:hover
                opacity: .7
                color: $black
                background-color: $gray
        &:hover
            border-bottom: 1px solid black

    .youtube-link
        margin-bottom: 10px

    .main-chat .item__content
        width: 100%

    .main-chat h4
        display: inline-block

    .main-chat .item__content a span
        display: inline-block
        margin-left: 5px
        color: rgba(#2B303A, 0.66)
        pointer-events: none

    .images-container,
    .image-link
        display: flex
        flex-wrap: wrap
        justify-content: flex-start
        margin-bottom: 10px

        .silentbox-single
            display: block
            margin: 0 10px 10px
            max-width: 300px
            width: fit-content

            img
                max-height: 180px
                object-fit: contain
                max-width: 100%

    .item__content .item-content__message a
        margin-bottom: 0
        display: inline-block

    .item-content__message .link
        cursor: pointer !important

    .spring-spinner, .spring-spinner *
        box-sizing: border-box

    .spring-spinner
        height: 20px
        width: 20px

    .spring-spinner .spring-spinner-part
        overflow: hidden
        height: calc(20px / 2)
        width: 20px

    .spring-spinner .spring-spinner-part.bottom
        transform: rotate(180deg) scale(-1, 1)

    .spring-spinner .spring-spinner-rotator
        width: 20px
        height: 20px
        border: calc(20px / 7) solid transparent
        border-right-color: #A1A9B6
        border-top-color: #A1A9B6
        border-radius: 50%
        box-sizing: border-box
        animation: spring-spinner-animation 3s ease-in-out infinite
        transform: rotate(-200deg)

    @keyframes spring-spinner-animation
        0%
            border-width: calc(20px / 7)

        25%
            border-width: calc(20px / 23.33)

        50%
            transform: rotate(115deg)
            border-width: calc(20px / 7)

        75%
            border-width: calc(20px / 23.33)

        100%
            border-width: calc(20px / 7)

</style>

